import { render, staticRenderFns } from "./UserRoleEdit.vue?vue&type=template&id=d78df6e4&scoped=true&"
import script from "./UserRoleEdit.vue?vue&type=script&lang=js&"
export * from "./UserRoleEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleEdit.vue?vue&type=style&index=0&id=d78df6e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78df6e4",
  null
  
)

export default component.exports